import { atom } from 'recoil';

export const DirectionDataState = atom({
    key: 'DirectionDataState', 
    default: null, 
});